module.exports = __webpack_public_path__ + "static/img/finance_bg_large.ec2e27fe.jpg";